import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { VaultDateTimePipe } from '@shared/pipes/vault-date-time.pipe';
import { StandardAccountDictionaryVersion } from '@interfaces/accounting-data-standardization/responses/standard-account-dictionary-governance.response';
import {
  changeSourceLabel,
  statementTypeLabel,
} from '@src/app/features/dashboard/accounting-data-standardization/utils/standard-account-dictionary-governance.util';

/** Verbetes alterados mostrados por versão; o resto vira "e mais N". */
const MAX_CHANGED_ENTRIES = 8;

/**
 * Seção "Histórico de versões" da aba Dicionário (PBI 3423, DPA-DIC-DB): linha do tempo da mais nova para a mais antiga,
 * com origem (tag), resumo, motivo, quem, quando e os verbetes alterados. A ativa fica destacada; nas aposentadas, com
 * MANAGE, "Voltar para esta versão" (que cria uma versão nova a partir dela: o histórico nunca é reescrito).
 */
@Component({
  selector: 'app-dictionary-version-timeline',
  standalone: true,
  imports: [SharedModule, VaultDateTimePipe],
  templateUrl: './dictionary-version-timeline.component.html',
  styleUrl: './dictionary-version-timeline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DictionaryVersionTimelineComponent {
  readonly versions = input<StandardAccountDictionaryVersion[]>([]);
  readonly canManage = input(false);
  /** Outra ação do painel está em andamento: trava os botões. */
  readonly locked = input(false);

  readonly rollbackRequested = output<StandardAccountDictionaryVersion>();

  protected readonly maxChangedEntries = MAX_CHANGED_ENTRIES;
  protected readonly sourceLabel = changeSourceLabel;
  protected readonly statementTypeLabel = statementTypeLabel;
}
